import { ref } from 'vue';

export const useModal = () => {
  const isModalOpen = ref(false);

  const changeModalVisibility = () => {
    isModalOpen.value = !isModalOpen.value;
  };

  return {
    isModalOpen,
    changeModalVisibility,
  };
};
